import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: "awh1c5s6",
    dataset: "production",
    useCdn: true
})